














































import Vue, { PropType } from 'vue'
import { FfhProductType } from '@/types/generated/graphql'
import XPrice from '@/components/atoms/Price/XPrice.vue'

type Props = {
  ffhProductTypes: Array<FfhProductType>
  unit: string
}

export default Vue.extend<{}, {}, {}, Props>({
  name: 'SetTypeTable',
  components: { XPrice },
  props: {
    ffhProductTypes: {
      type: Array as PropType<Array<FfhProductType>>,
      required: true,
    },
    unit: {
      type: String,
      required: true,
    },
  },
})
